<div class="container">
  <div class="row">
    <div class="col">
      <h1 class="text-center mb-5">Utils</h1>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col">
      <h1 class="text-center mb-5">Inputs</h1>
      <mat-form-field class="InputPadrao">
        <mat-label>Input texto</mat-label>
        <input type="text" matInput required />
      </mat-form-field>
      <br /><br />

      <mat-form-field class="InputPadrao">
        <mat-label>Input numero</mat-label>
        <input type="number" matInput required />
        <mat-hint>Apenas números</mat-hint>
      </mat-form-field>
      <br /><br />

      <mat-form-field class="InputPadrao">
        <mat-label>Input senha</mat-label>
        <input type="password" matInput required />
        <mat-icon
          aria-hidden="false"
          aria-label="visibility"
          class="InputIcon IconSeePass"
          >visibility</mat-icon
        >
      </mat-form-field>
      <br /><br />

      <mat-form-field class="InputPadrao">
        <mat-label>Input com icone</mat-label>
        <input type="text" matInput required />
        <mat-icon
          aria-hidden="false"
          aria-label="done"
          class="InputIcon IconCheck"
          >done</mat-icon
        >
      </mat-form-field>
      <br /><br />

      <mat-form-field class="InputPadrao">
        <mat-label>Select</mat-label>
        <mat-select>
          <mat-option>RJ</mat-option>
          <mat-option>SP</mat-option>
          <mat-option>MG</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col">
      <h1 class="text-center mb-5">Botões</h1>
      <button class="Btn BtnPadrao" type="button" mat-button>
        Botão padrão sem icone
      </button>
      <br />

      <button class="Btn BtnPadrao" type="button" mat-button>
        Botão com icone
        <mat-icon aria-hidden="false" aria-label="east">east</mat-icon>
      </button>
      <br />

      <button class="Btn BtnDisable" type="button" mat-button>
        Botão Desabilitado
        <mat-icon aria-hidden="false" aria-label="visibility_off"
          >visibility_off</mat-icon
        >
      </button>
      <br />

      <button class="Btn BtnPadrao" type="button" mat-button>
        <mat-icon aria-hidden="false" aria-label="sync">sync</mat-icon>
      </button>
      <br />

      <button class="Btn BtnBorder" type="button" mat-button>
        <mat-icon aria-hidden="false" aria-label="whatsapp">whatsapp</mat-icon>
        Botão com icone e borda
      </button>
      <br />

      <button class="Btn BtnSucess" type="button" mat-button>
        Botão sucesso
        <mat-icon aria-hidden="false" aria-label="done">done</mat-icon>
      </button>
    </div>
    <div class="col">
      <h1 class="text-center mb-5">Check/Radio/etc..</h1>
      <mat-checkbox class="InputPadrao"> Input Check </mat-checkbox>
      <br /><br /><br />
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Input Radio</mat-radio-button>
      </mat-radio-group>
      <br /><br /><br />
      <mat-slide-toggle>Slide me!</mat-slide-toggle>
      <br /><br />
      <br /><br />
    </div>
  </div>
</div>
